import { CACHE_CONFIG_TYPES, COOKIE_NAMES, STORE_NAME } from '@intigral/constant';
import { get } from '@intigral/utils/lib/browser-storage/localStorage';
import { getCookie } from '@intigral/utils/lib/browser-storage/cookie';

/**
 * Resolves the CMS / gateway app key for WCP bootstrap (config, language, data domain).
 * Prefers the logged-in or guest session key, then static env keys.
 */
export const resolveWcpAppKey = (): string | null => {
    const userLocalStorage = get(CACHE_CONFIG_TYPES.user) as { apiKey?: string } | null;
    if (userLocalStorage?.apiKey) {
        return userLocalStorage.apiKey;
    }

    const apiKeyCookie = getCookie(COOKIE_NAMES.USER_API_KEY);
    if (apiKeyCookie) {
        return apiKeyCookie;
    }

    const userLocalSession = getCookie(COOKIE_NAMES.USER_SESSION);
    if (userLocalSession) {
        try {
            const userObject = JSON.parse(window.atob(decodeURIComponent(userLocalSession)));
            if (userObject?.a) {
                return userObject.a;
            }
        } catch {
            // ignore parse errors
        }
    }

    const guestConfig = get(STORE_NAME.GUEST_PUBLIC_CONFIG) as { envKey?: string } | null;
    if (guestConfig?.envKey) {
        return guestConfig.envKey;
    }

    return process.env['NX_PUBLIC_WCP_STATIC_API_KEY'] || null;
};
